<template>
  <div class="">
    <transition name="fade">
      <div
        v-if="showRequestLeave"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <div
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-1/2 w-full h-full md:h-5/6 overflow-y-auto"
        >
          <img
            class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md fixed right-2 top-2 z-50"
            src="@/assets/icons/cross-white.png"
            @click="close()"
          />
          <!-- {{ LeaveTypes }} -->
          <!-- {{ selectedLeaveType }} -->

          <el-tabs
            type="border-card"
            v-model="activeName"
            style="border: none !important"
          >
            <transition name="fade">
              <div
                v-if="loading"
                class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
              >
                <loader class="center-h-v" />
              </div>
            </transition>
            <el-tab-pane label="Leave Form" name="leaveForm">
              <div class="flex justify-between items-left border-b-1.5 p-3">
                <p class="text-base">Request Leave</p>
              </div>
              <transition name="fade">
                <div
                  v-if="create_error"
                  class="p-1 text-center text-sm w-full bg-yellow-200"
                >
                  {{ create_error }}
                </div>
              </transition>
              <div class="grid grid-cols-2 p-4 gap-3">
                <div class="text-sm">
                  <label class="block pb-1"
                    >Leave Type <span class="text-red-700">*</span></label
                  >
                  <select
                    @change="getMinimumDate"
                    @blur="getMinimumDate"
                    required
                    class="p-2 bg-gray-200 rounded-full w-full"
                    v-model="selectedLeaveType"
                  >
                    <option
                      v-for="(LeaveType, index) in LeaveTypes"
                      :key="index"
                    >
                      {{ LeaveType.Name }}
                    </option>
                  </select>
                </div>

                <div class="text-sm">
                  <label class="block pb-1"
                    >Leave Span <span class="text-red-700">*</span></label
                  >
                  <div
                    class="flex flex-wrap justify-between bg-gray-200 rounded-md px-2 py-2.5"
                    style="display: flex; align-items: center"
                  >
                    <label
                      class="b-contain"
                      style="display: flex; align-items: center"
                    >
                      <span>Full Day</span>
                      <input
                        :checked="info.LeaveSpan === 'Full Day'"
                        @click="toggleLeaveSpan('Full Day')"
                        type="radio"
                        name="leave-span"
                      />
                      <div class="b-input"></div>
                    </label>
                    <label
                      class="b-contain"
                      style="display: flex; align-items: center"
                    >
                      <span>Half Day</span>
                      <input
                        :checked="info.LeaveSpan === 'Half Day'"
                        @click="toggleLeaveSpan('Half Day')"
                        type="radio"
                        name="leave-span"
                      />
                      <div class="b-input"></div>
                    </label>
                  </div>
                </div>
                <div
                  class="text-sm"
                  v-if="selectedLeaveType.toLowerCase().includes('annual')"
                >
                  <label class="">
                    Use Leave as Emergency
                    <el-popover trigger="hover" width="250" placement="top-left"
                      ><el-button
                        slot="reference"
                        class="el-icon-info"
                        type="text"
                      ></el-button>
                      <p>
                        <em>Emergency</em> leave overides policy days.
                      </p></el-popover
                    >
                  </label>
                  <div class="text-sm mt-1 p-2 py-2.5 bg-gray-200 rounded-md">
                    <input
                      type="checkbox"
                      class="cursor-pointer"
                      v-model="info.Emergency"
                    />
                    <label> Is Emergency</label>
                  </div>
                </div>

                <div class="text-sm">
                  <label class="block pb-1"
                    >Start Date<span class="text-red-700">*</span>
                    <el-popover trigger="hover" width="250" placement="top-left"
                      ><el-button
                        slot="reference"
                        class="el-icon-info"
                        type="text"
                      ></el-button>
                      <p>
                        <em>Start Date</em> is the date your leave will be
                        effect from.
                      </p></el-popover
                    >
                  </label>
                  <!-- First input for leave types other than 'sick' -->
                  <input
                    v-if="!selectedLeaveType.toLowerCase().includes('sick')"
                    @change="calculatePeriod"
                    v-model="info.StartDate"
                    :disabled="!selectedLeaveType.trim().length"
                    type="date"
                    :min="
                      info.Emergency
                        ? new Date()
                        : new Date(minimumSelectableDate)
                            .toISOString()
                            .split('T')[0]
                    "
                    class="p-2 bg-gray-200 rounded-full w-full"
                    placeholder="Leave Type"
                    required
                  />

                  <!-- Second input for 'sick' leave type -->
                  <input
                    v-if="selectedLeaveType.toLowerCase().includes('sick')"
                    @change="calculatePeriod"
                    v-model="info.StartDate"
                    class="p-2 bg-gray-200 rounded-full w-full"
                    placeholder="Sick Leave Start Date"
                    type="date"
                    required
                  />

                  <!--  new Date(minimumSelectableDate).toISOString().split('T')[0] -->
                </div>
                <div class="text-sm">
                  <label class="block pb-1"
                    >End Date <span class="text-red-700">*</span>
                    <el-popover trigger="hover" width="250" placement="top-left"
                      ><el-button
                        slot="reference"
                        class="el-icon-info"
                        type="text"
                      ></el-button>
                      <p>
                        <em>End Date</em> is the last day of your leave. You are
                        expected to report to work the day after this date.
                      </p></el-popover
                    >
                  </label>
                  <input
                    @change="calculatePeriod"
                    v-model="info.EndDate"
                    :disabled="inputDisabled"
                    type="date"
                    :min="new Date(info.StartDate).toISOString().split('T')[0]"
                    class="p-2 bg-gray-200 rounded-full w-full"
                    placeholder="Leave Type"
                    required
                  />
                </div>
                <div class="text-sm">
                  <label class="block pb-1"
                    >Days
                    <el-popover trigger="hover" width="250" placement="top-left"
                      ><el-button
                        slot="reference"
                        class="el-icon-info"
                        type="text"
                      ></el-button>
                      <p>
                        <em>Days</em> is the number of days that will be
                        deducted from your earned leave days.
                      </p></el-popover
                    >
                  </label>
                  <input
                    disabled
                    class="p-2 bg-gray-200 rounded-full w-full disabled border-0.5"
                    v-model="info.Period"
                    required
                  />
                </div>
              </div>

              <div class="p-4">
                <label
                  >Attachment
                  <span class="text-red-900" v-if="isAttchmentRequired">*</span>
                </label>

                <input
                  v-on:change="getFile"
                  type="file"
                  accept=".pdf,image/jpeg,image/png"
                  class="p-2 bg-gray-200 rounded-full w-full"
                  placeholder="Leave Type"
                  :required="isAttchmentRequired"
                />
              </div>
              <div class="p-4">
                <label
                  >Description
                  <span class="text-red-900" v-if="info.Emergency">*</span>
                </label>
                <textarea
                  v-model="info.Description"
                  class="p-1 bg-gray-200 rounded-xl w-full"
                  cols="5"
                  :required="info.Emergency"
                ></textarea>
              </div>
              <div
                class="flex justify-end p-5"
                v-if="activeName === 'leaveForm'"
              >
                <div
                  role="button"
                  class="bg-primary rounded-md px-10 text-sm text-white py-2"
                  @click="proceedToHandover"
                >
                  Proceed
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="Handover Notes" name="handoverNotes">
              <div class="overflow-y-auto">
                <CustomEditor
                  :handleSubmit="handleSubmit"
                  :handleContentChangedLocal="handleContentChangedLocal"
                ></CustomEditor>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </transition>
    <!-- <leave-date-picker></leave-date-picker> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Loader from '@/components/loader/loader.vue';
import axios from 'axios';
import moment from 'moment';
// import tynyMCE from "@/components/editor/tynyMCE.vue";
import CustomEditor from './../editor/CustomEditor.vue';

export default {
  name: 'RequestLeave',
  props: [
    'showRequestLeave',
    'isSubmitted',
    'closeOnSuccess',
    'leaveRequestCallback',
  ],
  components: {
    Loader,

    CustomEditor,
  },
  data() {
    return {
      handoverNotes: null,
      activeName: 'leaveForm',
      create_error: null,
      loading: false,
      inputDisabled: true,
      currentDate: null,
      dateError: false,
      selectedDate: null,
      policyDays: null,
      inputId: 'my-date-field-' + Math.floor(Math.random() * 100000),
      popoverId: 'my-popover-' + Math.floor(Math.random() * 100000),
      highlightDates: [
        {
          backgroundColor: '#e6f7ff',
          dates: [
            new Date('2023-03-25'),
            new Date('2023-03-28'),
            new Date('2023-03-30'),
          ],
        },
        {
          backgroundColor: '#ffe6e6',
          dates: [new Date('2023-04-01'), new Date('2023-04-05')],
        },
      ],
      LeaveTypes: [],
      selectedLeaveType: '',
      minimumSelectableDate: new Date(),
      isAttchmentRequired: false,
      holidays: null,
      info: {
        LeaveType: null,
        StartDate: null,
        Period: null,
        date: null,
        EndDate: null,
        LeaveAttachment: '',
        Description: '',
        LeaveSpan: 'Full Day',
        Emergency: false,
      },
    };
  },
  computed: {
    ...mapGetters(['getOrganization', 'getToken']),

    leaveTypeID() {
      if (this.selectedLeaveType) {
        // console.log(this.selectedLeaveType);
        const leave = this.LeaveTypes.find(({ Name }) => {
          return (
            Name.trim().toLowerCase() ===
            this.selectedLeaveType.trim().toLowerCase()
          );
        });
        this.getMinimumDate(leave);
        return leave.Id;
      }

      return null;
    },
  },
  created() {
    this.getLeaveTypes();
    this.getHolidays();
  },
  watch: {
    selectedLeaveType() {
      const mandatoryLeaveKeywords = ['sick', 'paternity', 'maternity'];
      const selectedLeaveTypeLower = this.selectedLeaveType.toLowerCase();
      this.isAttchmentRequired = mandatoryLeaveKeywords.some((keyword) =>
        selectedLeaveTypeLower.includes(keyword),
      );
      //console.log(this.isAttchmentRequired, selectedLeaveTypeLower)
      if (this.policyDays && !this.info.Emergency) {
        this.$notify.info({
          title: 'Policy Days',
          message: `You will apply for leave after ${this.policyDays} notice days from today`,
        });
      }
      if (this.isEmergencyChecked()) {
        this.policyDays = 0;
      }
    },
    info: {
      deep: true,
      handler() {
        // If Emergency is checked, set policyDays to 0
        if (this.isEmergencyChecked()) {
          this.policyDays = 0;
        }
      },
    },
    LeaveTypes() {
      if (this.LeaveTypes && !this.LeaveTypes.length) {
        this.$notify.warning({
          title: 'No Leave Types',
          message: `You have not been assigned any leave types yet`,
        });
      }
    },
  },
  methods: {
    handleContentChangedLocal(newContent) {
      console.log(newContent);
      this.handoverNotes = newContent;
    },
    handleSubmit() {
      // console.log(e);
      // this.handoverNotes = e;
      let { HandoverNotesRequired } = this.LeaveTypes.find(
        (l) =>
          l.Name.trim().toLowerCase() ===
          this.selectedLeaveType.trim().toLowerCase(),
      );
      if (HandoverNotesRequired && !this.handoverNotes) {
        this.$notify.error({
          title: 'Incomplete Submission',
          message:
            'This leave type requires you to submit handover notes. Kindly fill the handover notes form and submit again',
        });
        this.activeName = 'handoverNotes';
      } else {
        this.create();
      }
    },
    proceedToHandover() {
      this.activeName = 'handoverNotes';
    },
    isEmergencyChecked() {
      return this.info.Emergency;
    },
    toggleLeaveSpan(value) {
      this.info.LeaveSpan = this.info.LeaveSpan === value ? 'Full Day' : value;
      this.calculatePeriod();
    },
    close() {
      this.loading = false;
      this.$emit('close');
      this.info = {
        LeaveType: null,
        StartDate: null,
        Period: 0,
        date: null,
        EndDate: null,
        LeaveAttachment: '',
        Description: '',
        LeaveSpan: 'Full Day',
        Emergency: false,
      };
      this.selectedLeaveType = '';
      this.policyDays = null;
    },
    getFile({ target }) {
      const file = target.files[0];
      this.info.LeaveAttachment = file;
    },

    getMinimumDate() {
      const leave = this.LeaveTypes.find(
        ({ Name }) =>
          Name.trim().toLowerCase() ===
          this.selectedLeaveType.trim().toLowerCase(),
      );

      console.log(leave);

      const currentDate = new Date();

      const { PolicyDays } = leave;
      // console.log(PolicyDays);
      this.policyDays = PolicyDays;
      this.minimumSelectableDate = new Date(
        currentDate.getTime() + PolicyDays * 24 * 60 * 60 * 1000,
      );
    },
    // // Calculate leave Period
    // calculatePeriod() {
    //   const startDate = new Date(this.info.StartDate);
    //   const endDate = new Date(this.info.EndDate);

    //   this.inputDisabled = false;
    //   if (startDate && endDate) {
    //     if (endDate < startDate) {
    //       this.minimumSelectableDate = startDate;
    //       this.info.EndDate = null;
    //       this.info.Period = null;
    //       return;
    //     }

    //     // Calculate the difference in StartDate and EndDate
    //     let startDateMoment = moment(startDate);
    //     let endDateMoment = moment(endDate);
    //     let diffInMilliseconds = endDateMoment.diff(startDateMoment);

    //     let duration = moment.duration(diffInMilliseconds, 'milliseconds');
    //     let diffInDays = duration.asDays();

    //     // Include the end date as part of the leave period
    //     const totalDays = diffInDays + 1;

    //     // Initialize counters for Saturdays and Sundays
    //     let numSaturdays = 0;
    //     let numSundays = 0;

    //     // Initialize counters for holidays
    //     let numOfHolidays = [];

    //     // Loop through each day in the range
    //     for (
    //       let date = new Date(startDate);
    //       date <= endDate;
    //       date.setDate(date.getDate() + 1)
    //     ) {
    //       // Check if the current day is a Saturday or Sunday
    //       if (date.getDay() === 0) {
    //         numSundays++;
    //       } else if (date.getDay() === 6) {
    //         numSaturdays++;
    //       }
    //     }
    //     // console.log(numOfHolidays);
    //     // Loop through each day in the range and check for holidays
    //     for (
    //       let date = new Date(startDate);
    //       date <= endDate;
    //       date.setDate(date.getDate() + 1)
    //     ) {
    //       this.holidays.filter((holiday) => {
    //         const holidayDate = new Date(holiday.ISO);

    //         if (
    //           holidayDate.getDate() === date.getDate() &&
    //           holidayDate.getMonth() === date.getMonth() &&
    //           holidayDate.getFullYear() === date.getFullYear() &&
    //           date.getDay() !== 0
    //         ) {
    //           // console.log(holidayDate);
    //           numOfHolidays.push(holiday);
    //         }
    //       });
    //     }

    //     // Subtract holidays
    //     const daysAfterHolidays = totalDays - numOfHolidays.length;

    //     const leave = this.LeaveTypes.find(
    //       ({ Name }) =>
    //         Name.trim().toLowerCase() ===
    //         this.selectedLeaveType.trim().toLowerCase()
    //     );

    //     const { IncludeSaturday } = leave;
    //     let adjustedDays = daysAfterHolidays;

    //     if (!IncludeSaturday) {
    //       // Remove Saturdays
    //       adjustedDays -= numSaturdays;
    //     } else if (IncludeSaturday && leave.SaturdayHalf) {
    //       adjustedDays -= numSaturdays / 2;
    //     } else if (IncludeSaturday && leave.SaturdayFull) {
    //       adjustedDays += numSaturdays;
    //     }

    //     // Remove Sundays always
    //     adjustedDays -= numSundays;

    //     if (this.info.LeaveSpan.trim().toLowerCase() === 'half day') {
    //       adjustedDays = adjustedDays / 2;
    //     }

    //     // Log the results to the console
    //     if (adjustedDays < 0) {
    //       this.info.Period = '';
    //     } else {
    //       this.info.Period = parseFloat(adjustedDays).toFixed(2);
    //     }
    //   }
    // },

    calculatePeriod() {
      const startDate = new Date(this.info.StartDate);
      const endDate = new Date(this.info.EndDate);

      this.inputDisabled = false;

      // Enforce minimum selectable date for non-emergency, non-sick leave
      if (
        this.info.StartDate &&
        !this.info.Emergency &&
        !this.selectedLeaveType.toLowerCase().includes('sick') &&
        startDate <
          new Date(new Date(this.minimumSelectableDate).setHours(0, 0, 0, 0))
      ) {
        this.$notify.error({
          title: 'Invalid Date',
          message: `You must apply for leave at least ${this.policyDays} notice days from today`,
        });
        this.info.StartDate = null;
        this.info.EndDate = null;
        this.info.Period = null;
        this.inputDisabled = true;
        return;
      }

      if (startDate && endDate) {
        if (endDate < startDate) {
          this.minimumSelectableDate = startDate;
          this.info.EndDate = null;
          this.info.Period = null;
          return;
        }

        // Calculate total difference in days including endDate
        const startDateMoment = moment(startDate);
        const endDateMoment = moment(endDate);
        const totalDays = endDateMoment.diff(startDateMoment, 'days') + 1;

        // Initialize counters for Saturdays, Sundays, and holidays
        let numSaturdays = 0;
        let numSundays = 0;
        let numOfHolidays = 0;

        // Loop through the range once to count weekends and holidays
        for (
          let date = new Date(startDate);
          date <= endDate;
          date.setDate(date.getDate() + 1)
        ) {
          const dayOfWeek = date.getDay();

          // Check for Sundays (always excluded)
          if (dayOfWeek === 0) {
            numSundays++;
            continue; // Skip further checks if it's a Sunday
          }

          // Check for Saturdays
          if (dayOfWeek === 6) numSaturdays++;

          // Check for holidays (not Sundays)
          const isHoliday = this.holidays.some((holiday) =>
            moment(date).isSame(holiday.ISO, 'day'),
          );
          if (isHoliday) numOfHolidays++;
        }

        // Calculate leave by subtracting Sundays and holidays
        let adjustedDays = totalDays - numSundays - numOfHolidays;

        // Adjust based on leave type
        const leave = this.LeaveTypes.find(
          ({ Name }) =>
            Name.trim().toLowerCase() ===
            this.selectedLeaveType.trim().toLowerCase(),
        );

        if (leave) {
          const { IncludeSaturday, SaturdayHalf, SaturdayFull } = leave;

          if (!IncludeSaturday) {
            adjustedDays -= numSaturdays;
          } else if (SaturdayHalf) {
            adjustedDays -= numSaturdays / 2;
          } else if (SaturdayFull) {
            adjustedDays += numSaturdays;
          }
        }

        // Handle half-day leave spans
        if (this.info.LeaveSpan.trim().toLowerCase() === 'half day') {
          adjustedDays = adjustedDays / 2;
        }

        // Ensure the final period is valid and positive
        this.info.Period = adjustedDays > 0 ? adjustedDays.toFixed(2) : '';
      }
    },
    getLeaveTypes() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };

      const leaveTypeRequest = axios.get(
        `${this.getOrganization}/timeoff/me/leave/type/${this.$ApiVersion}/request`,
        options,
      );

      const setupLeaveTypeRequest = axios.get(
        `${this.getOrganization}/setup/leavetype/${this.$ApiVersion}/request`,
        options,
      );

      axios
        .all([leaveTypeRequest, setupLeaveTypeRequest])
        .then(
          axios.spread((leaveTypeResponse, setupLeaveTypeResponse) => {
            this.loading = false;

            if (
              leaveTypeResponse.data.StatusCode === 200 &&
              setupLeaveTypeResponse.data.StatusCode === 200
            ) {
              const leaveTypeIds = leaveTypeResponse.data.Data.map(
                (item) => item.LeaveTypeId,
              );

              this.LeaveTypes = setupLeaveTypeResponse.data.Data.filter(
                (item) => leaveTypeIds.includes(item.Id),
              );
            }
          }),
        )
        .catch(() => {
          this.loading = false;
        });
    },

    getHolidays() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/holiday/${this.$ApiVersion}/request`,
          options,
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.holidays = response.data.Data;
              //console.log(this.holidays)
            }
          },
          () => {
            this.loading = false;
          },
        );
    },
    getHandoverNotes(handoverNotes) {
      this.loading = true;
      this.activeName = 'leaveForm';
      this.handoverNotes = handoverNotes;
      // console.log(handoverNotes);
    },
    create() {
      this.activeName = 'leaveForm';
      // Validation
      if (!this.isValidForm()) {
        return;
      }

      // console.log("ertyuiop");

      // Form data preparation
      const formData = new FormData();
      formData.append('LeaveType', this.info.LeaveType);
      formData.append('StartDate', this.info.StartDate);
      formData.append('Period', this.info.Period);
      formData.append('date', this.info.date);
      formData.append('EndDate', this.info.EndDate);
      formData.append('LeaveAttachment', this.info.LeaveAttachment);
      formData.append('Description', this.info.Description);
      formData.append('LeaveSpan', this.info.LeaveSpan.split(' ').join(''));
      formData.append(
        'Emergency',
        this.info.Emergency ? this.info.Emergency : false,
      );
      this.handoverNotes != null &&
        formData.append('HandoverNotes', this.handoverNotes);
      // console.log(this.handoverNotes);

      // HTTP request configuration
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          accept: '*/*',
          'Content-Type': 'multipart/form-data',
        },
      };

      // Sending the request
      this.loading = true;

      axios
        .post(
          `${this.getOrganization}/timeoff/${this.$ApiVersion}/create`,
          formData,
          options,
        )
        .then((response) => {
          this.handleSuccessResponse(response);
        })
        .catch((error) => {
          this.handleErrorResponse(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    isValidForm() {
      this.info.LeaveType = this.LeaveTypes.find(
        ({ Name }) =>
          Name.trim().toLowerCase() ===
          this.selectedLeaveType.trim().toLowerCase(),
      ).Id;

      if (
        !this.info.LeaveType ||
        !this.info.StartDate ||
        (!this.info.Period && this.info.Period != 0) ||
        !this.info.EndDate ||
        !this.info.LeaveSpan
      ) {
        this.$notify.error({
          title: 'Error',
          message: 'Invalid form. Fill in required fields to proceed',
        });
        return false;
      }

      if (
        this.selectedLeaveType.toLowerCase().trim().includes('annual') &&
        this.info.Emergency &&
        !this.info.Description
      ) {
        this.$notify.error({
          title: 'Error',
          message: 'Invalid form. Fill in required fields to proceed',
        });
        return false;
      }

      if (this.isAttachmentRequired() && !this.info.LeaveAttachment) {
        this.$notify.error({
          title: 'Error',
          message: 'Attachment is required for this leave type',
        });
        return false;
      }

      return true;
    },

    isAttachmentRequired() {
      // Add any additional conditions for attachment requirement here
      return (
        this.selectedLeaveType.toLowerCase().trim().includes('sick') ||
        (this.selectedLeaveType.toLowerCase().trim().includes('patenity') &&
          this.selectedLeaveType.toLowerCase().trim().includes('matenity'))
      );
    },

    handleSuccessResponse(response) {
      if (response.data.StatusCode === 200) {
        this.LeaveTypes = response.data.Data;
        this.success = response.data.StatusMessage;
        this.$notify({
          title: 'Success',
          message: response.data.StatusMessage,
          type: 'success',
        });
        this.leaveRequestCallback(response.data.StatusMessage, true);

        this.resetForm();
        this.close();
        this.getLeaveTypes();
        this.isSubmitted();
      } else {
        this.create_error = response.data.StatusMessage;
        this.$notify.error({
          title: 'Error',
          message: response.data.StatusMessage,
        });
        this.leaveRequestCallback(response.data.StatusMessage, true);
        setTimeout(() => {
          this.create_error = null;
        }, 1500);
      }
    },

    handleErrorResponse(error) {
      this.create_error = error.message;
      this.$notify.error({
        title: 'Error',
        message: error.message,
      });
      this.leaveRequestCallback(error.message, false);
      setTimeout(() => {
        this.create_error = null;
      }, 1500);
    },

    resetForm() {
      this.info = {
        LeaveType: null,
        StartDate: null,
        Period: null,
        date: null,
        EndDate: null,
        LeaveAttachment: '',
        Description: '',
        LeaveSpan: 'Full Day',
        Emergency: false,
      };
      this.selectedLeaveType = '';
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
